import { useTranslation } from 'react-i18next'

const PoliticianStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="politician-start-title"
      {...props}
    >
      <title id="politician-start-title">{t('antagonists:politician:components:start')}</title>
      <path
        d="m1497.34 942.34-2.13 42.94s-5.68 1.06-4.61 5.68c1.06 4.61-3.19 14.55-7.1 17.04-3.9 2.48-38.33.71-43.3-1.77-4.97-2.48-.71-11.71-.35-16.33.35-4.61 4.26-9.23 7.45-18.1 3.19-8.87 7.81-19.16 8.87-24.84 1.06-5.68-7.86-23-7.86-23l49.03 18.38ZM1594.86 928.04l-2.48 52.53s17.75 3.9 22 10.29 13.13 14.55 17.39 15.62c4.26 1.06 39.04.71 39.75-2.48.71-3.19 1.77-17.39-3.55-22-5.32-4.61-17.04-12.07-20.58-21.29-3.55-9.23-9.17-29.06-9.17-29.06l-43.36-3.59Z"
        style={{
          fill: '#00101f',
        }}
      />
      <path
        d="M1447.39 517.78s-4.29 21.11-9.53 82.25c-5.65 65.93-.65 107.2-2.23 143.25s5.02 107.37 6.6 141.92c1.58 34.55 2.17 66.71 2.17 66.71s12.59 9.89 31.57 8.39 27.9-4.49 27.9-4.49 6.22-163.15 7.8-187.19c1.58-24.04 18.23-115.1 20.46-115.05 5.7.14 38.18 121.5 38.18 139.52S1590.7 948 1590.7 948s24.48 6.52 35.62 7.38c14.19 1.1 22.4-7.11 22.4-7.11s.72-124.29-2.03-169.68c-3.24-53.36-22.87-136.32-30.33-187.79-7.46-51.47-13.43-96.97-13.43-96.97l-155.55 23.92Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1508.06 287.54c-5 5-11.67 15.1-24.02 21.62-12.36 6.52-52.5 28.83-54.57 51.89-5.92 65.8 7.47 139.08 6.79 154.19-.69 15.1-4.72 38.39-5.4 52.12-.69 13.73-2.27 34.54-2.27 34.54s77.99 23.31 114.71 19.19c36.72-4.12 92.64-20.34 92.64-20.34s-9.95-81.95-9.27-113.52c.69-31.57-8.44-83.34-13.93-113.54-5.49-30.2 7.02-38.42-2.93-44.94-9.95-6.52-38.94-20.27-45.81-23.36-6.86-3.09-54.23-19.56-55.94-17.85Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1541.31 358.1c.26.55 4.07 107.55 4.07 107.55l2.27.5s1.19-25.37 3.11-53.65c1.26-18.57 8.59-70.11 7.13-80.25-2.56-17.77-1.21-35-1.88-34.74-.67.27-41.47-17.17-42.54-17.17s-10.91 1.08-10.37 7.94c.54 6.87 35.65 64.35 38.21 69.8Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1495.2 446.6c-4.05 3.04-16.63 14.64-16.63 14.64s.67 3.55 3.1 3.55c2.44 0 7.54-2.44 7.54-2.44l-3.77 5.54s4.44 3.33 7.32 1.55c2.88-1.77 5.54-3.55 5.54-3.55l-3.77 5.99s2.44 2.66 6.21.22 15.08-11.75 17.08-10.42c2 1.33 14.86 11.75 22.84 13.31 7.98 1.55 34.15-2.88 34.15-2.88l-7.54-22.18s-16.19 6.21-23.06 2.22c-6.87-3.99-19.07-10.2-26.61-11.53-7.54-1.33-17.96 2.66-22.4 5.99Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1547.32 452.54s2.67 5.9 3.86 13c1.18 7.1 2.75 18.69 2.75 18.69s76.43-7.23 89.14-14.33c12.71-7.1 12.5-17.21 10.73-28.45-1.77-11.24-8.61-18.97-37-15.71-28.39 3.25-36.78 15.92-47.72 18.88-10.94 2.96-21.76 7.91-21.76 7.91Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1609.81 328.74c17.25 16.14 36.69 92.08 42.22 105.9 5.53 13.82-9.13 22.17-9.13 22.17l-47.76 12.76-13.82-131.78 28.5-9.05Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1508.04 263.24s1.42 13.35-.4 19.01c-1.82 5.66.73 8.29.73 8.29-1.03-.22 17.58 19.34 26.89 20.58 7.8 1.04 21.94-13.34 21.94-13.34s-.18-1.23.83-9.73c1.01-8.49 6.03-22.59 6.03-22.59l-56.01-2.22Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1543.23 182.59c-12.62-1.11-17.01 4.12-23.81 8.24-6.8 4.11-15.35 5.31-17.44 22.09-2.1 16.78-1.67 33.35-1.67 33.35l72.38 3.5s3.95-8.26 2.9-27.14c-1.05-18.88-8.4-37.94-32.35-40.04Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        d="M1543.03 187.24c-10.46-.85-21.74 3.71-29.33 10.79-5.87 5.47-2.21 21.5-2.38 26.74-.17 5.24-4.55 14.86-4.55 14.86s-5.94-11.36-11.01-8.22c-5.07 3.15-.7 27.97 4.02 29.37 4.72 1.4 4.44 1.6 4.44 1.6s.5 13.41 6.44 20.75 21.99 14.89 28.63 14.19c6.64-.7 23.13-9.3 25.75-14.54 2.62-5.24 3.04-16.99 3.04-16.99s4.7 1.17 7.5-4.25 4.62-21.2 2.35-23.47c-2.27-2.27-6.63 1.07-6.63 1.07s4.02-21.85 1.05-29.37c-2.97-7.52-20.75-21.82-29.32-22.52Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1530.68 238.46c-1.75.6-2.57 2.21-1.92 3.9.66 1.69 2.01 2 3.61 1.56 1.89-.52 2.57-2.01 2.07-3.81-.35-1.28-1.96-2.27-3.76-1.65Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        style={{
          fill: '#272a3e',
        }}
        d="m1525.13 239.55 10.42.96.44-2.88-9.99-2.6-.87 4.52zM1556.73 239.5c1.75.6 2.57 2.21 1.92 3.9-.66 1.69-2.01 2-3.61 1.56-1.89-.52-2.57-2.01-2.07-3.81.35-1.28 1.96-2.27 3.76-1.65Z"
      />
      <path
        style={{
          fill: '#272a3e',
        }}
        d="m1561.6 241.15-9.92.36-.33-2.55 9.96-2.18.29 4.37z"
      />
      <path
        d="M1541.47 229.33s-5.35-4.21-11.25-4.35c-5.9-.14-11.28 5.14-11.28 5.14l1.18 1.61s3.36-.28 9.02-.32c4.64-.04 10.45 2.67 10.45 2.67l1.87-4.75ZM1549.29 230.12l1.75 5.66s4.77-2.73 8.94-1.43c4.18 1.3 6.76.73 6.76.73l1.62-2.45s-4.53-3.95-10.72-3.8c-6.19.14-8.35 1.3-8.35 1.3Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        style={{
          fill: '#d88b46',
        }}
        d="m1532.71 244.35-8.83 11 3.34 1.19 9.46-8.67-3.97-3.52zM1551.8 248.4l7.84 9.57 3.65-1.91-6.96-10.44-4.53 2.78zM1528.26 273.01l1.86 10.26-3.34.6-2.42-11 3.9.14zM1557.83 273.38l-3.4-1.3-3.16 9.43 2.5.72 4.06-8.85z"
      />
      <path
        d="M1576.39 239.15s-2.68-.07-4.83-1.18c-1.68-.87-2.37-3.7-8.4-5.06-6.04-1.35-11.31 1.12-13.11 2.02-1.07.53-6.99.59-8.76-.71-1.74-1.27-4.65-4.97-11.42-4.9-8.12.08-9.88 1.99-13.27 2.38-2.05.24-7.22-1.92-7.22-1.92l-1 2.49s7.77 2.93 7.77 5.42.73 12.31 11.33 13.54c6.88.8 10.53-1.49 13.4-5.58 2-2.86 1.84-6.48 2.58-7.17.47-.44 3.45-.37 3.87.29.52.82-.64 4.12.72 7.52 1.69 4.24 4.32 7.4 11.46 8.02 9.7.85 12.41-7.48 13.63-9.65 1.18-2.11 3.26-2.57 3.26-2.57v-2.96Zm-41.05 8.4c-4.02 2.35-10.9 1.47-13.59-1.81-2.7-3.28-3.69-7.29-1.71-10.08 2.31-3.25 6.75-3.94 11.21-3.49 5.22.54 8.19 3.88 8.68 6.77s-.56 6.26-4.58 8.61Zm31.26 2.63c-3.04 2.68-10.67 2.1-13.81-1.01-3.13-3.11-3.42-6.62-2.43-9.35.99-2.73 4.26-4.95 9.05-4.89 4.64.06 8.84 1.92 10.27 5.57 1.23 3.13-.04 7-3.08 9.67Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1530.02 275.93c1.12 2.06 5.55 2.27 8.87 2.03 3.32-.24 5.39-1.87 8.45-2.52 1.17-.25 5.17.88 5.82-.82 1.07-2.8-8.02-5.85-14.65-5.36-6.64.49-9.86 4.18-8.49 6.68Z"
        style={{
          fill: '#ef8227',
        }}
      />
      <path
        d="m1536.65 279.72-14.82 4.1s-.46 17.56.23 22.34c.68 4.79 10.94 21.89 11.17 25.76s-2.05 16.87-2.05 16.87l25.08 5.93s-.23-11.17 1.6-14.14c1.82-2.96 3.19-4.33 3.42-10.26.23-5.93-3.88-21.66-3.88-21.66s1.35 2.61 3.67 2.61 3.81-.66 3.81-.66-.83-3.15-.99-6.8c-.17-3.65-.5-7.13-.5-7.13s-3.81-5.64-6.13-7.62c-2.32-1.99-7.29-.66-9.45-1.99-2.15-1.33-5.74-6.78-11.16-7.37Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1542.1 345.89c-7.8 0-15.48-1.72-15.48-1.72s-26.49 61.69-31.65 70.86c-5.16 9.17-10.32 34.39 5.16 43.56 15.48 9.17 25.32 16.39 42.52-12.84 17.2-29.23 14.23-53.08 18.24-69.7 4.01-16.62 4.13-22.13 4.13-22.13s-10.89-8.02-22.93-8.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        style={{
          fill: '#5b3346',
        }}
        d="m1536.98 633.25 9.67-70.54 2.27.5 13.01 70.13-24.95-.09z"
      />
    </svg>
  )
}

export default PoliticianStart
